module.exports = __webpack_public_path__ + "img/digital_4.27d319a8.png";